<script setup lang="ts">
import type {PropType} from 'vue'
import {type THomeSection, THomeSectionType} from "~/layers/homepage/data/types";

const props = defineProps({
  section: {
    type: Object as PropType<THomeSection>,
    required: true,
  },
})

const id = useId()

// @ts-ignore
const sliderType = props.section.sliderType || null
</script>

<template>
  <section
    class="main__section"
    :class="{
      // main__section_dark: sliderType === 'brilliants',
      main__slider: section.type === THomeSectionType.Slider,
      main__info:
        section.type === THomeSectionType.Animation ||
        section.type === THomeSectionType.DiamondHistory ||
        (section.type === THomeSectionType.Slider && sliderType === 'constructor'),
    }"
    :id
  >
    <slot />
  </section>
</template>
